import { useEffect, useRef } from 'react';

const useScrollToTopOnLocationChange = (ref: React.RefObject<HTMLElement>, hash?: string) => {
  const prevHashRef = useRef<string | undefined>(hash);

  useEffect(() => {
    // Only trigger if hash changed and is not the initial render
    if (hash !== prevHashRef.current && ref.current && !(typeof hash === 'string' && hash.startsWith('skip-'))) {
      const element = ref.current;
      element.scrollTop = 0;
    }
    
    // Update the previous hash value
    prevHashRef.current = hash;
  }, [hash, ref]);
};

export default useScrollToTopOnLocationChange;